import { type PrimaryPageAction, EmptyStateOnboarding, ExternalLink } from "@octopusdeploy/design-system-components";
import type { GetEphemeralEnvironmentsOnboardingDataBffResponse, ProjectResource } from "@octopusdeploy/octopus-server-client";
import { useTrackEvent, useAnonymizeEventProperty } from "@octopusdeploy/portal-analytics";
import { ephemeralEnvironmentConfigurationStart, EphemeralEnvironmentsConfigWizard } from "~/areas/projects/components/EphemeralEnvironments/ConfigurationWizard/EphemeralEnvironmentsConfigWizard";
import { useDialogTrigger } from "~/components/Dialog/DialogTrigger";
import { EphemeralEnvironmentsEmptyStateIllustration } from "./EphemeralEnvironmentsEmptyStateIllustration";
type EphemeralEnvironmentsOnboardingProps = {
    project: ProjectResource;
    onboardingData: GetEphemeralEnvironmentsOnboardingDataBffResponse;
    reloadConfiguration: () => void;
};
export function EphemeralEnvironmentsOnboarding({ project, onboardingData, reloadConfiguration }: EphemeralEnvironmentsOnboardingProps) {
    const configWizardDialogControls = useDialogTrigger();
    const trackEvent = useTrackEvent();
    const anonymize = useAnonymizeEventProperty();
    const canCreateChannels = onboardingData.Permissions.CreateChannels;
    function openConfigWizard() {
        configWizardDialogControls.openDialog();
        trackEvent({
            eventName: ephemeralEnvironmentConfigurationStart,
            "Space Id": anonymize(project.SpaceId),
            "Project Id": anonymize(project.Id),
        });
    }
    function closeConfigWizard() {
        configWizardDialogControls.closeAllDialogs();
        reloadConfiguration();
    }
    const primaryAction: PrimaryPageAction = {
        label: "Configure Ephemeral Environments",
        type: "button",
        onClick: openConfigWizard,
        disabled: !canCreateChannels,
        extraContext: !canCreateChannels ? "You need permission to create channels to configure ephemeral environments" : undefined,
    };
    return (<>
            <EmptyStateOnboarding description={<div>
                        <div>Automatically spin up test environments while keeping your infrastructure costs down.</div>
                    </div>} primaryAction={primaryAction} title="Gain confidence in your changes with test environments on demand" image={<EphemeralEnvironmentsEmptyStateIllustration />} learnMore={<ExternalLink href={"ephemeralenvironments"}>Learn more</ExternalLink>}/>
            <EphemeralEnvironmentsConfigWizard isOpen={configWizardDialogControls.isOpen} closeDialog={closeConfigWizard} onboardingData={onboardingData} project={project}/>
        </>);
}
